// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-nav[data-v-3179e828]{width:100vw}.mobile-nav a[data-v-3179e828]{font-weight:300}.mobile-nav-item[data-v-3179e828]{font-size:25px;font-weight:300}.nav button.button-color[data-v-3179e828]{color:#fff;-webkit-box-shadow:2px 1000px 1px #5c5c5c inset;box-shadow:inset 2px 1000px 1px #5c5c5c}.mobile-nav .mobile-content[data-v-3179e828]{position:fixed;width:100vw;height:100vh;right:0;overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
